import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FormDialog } from "@/component-create/FormDialog";
import { FORM_ITEM } from "@/components/form/enums";
import XTinyMce from '@/components/x-tiny-mce/XTinyMce.vue';
import { ElRadio, ElRadioGroup } from "element-plus";
import 'element-plus/es/components/radio/style/css'
import 'element-plus/es/components/radio-group/style/css'

import { MESSAGE_RECIPIENT, MESSAGE_STATUS } from "@/constant/system/code";
import DepartmentSelect from '@/views/components/DepartmentSelect.vue';
import UserSelector from '@/views/components/UserSelector.vue';
import { MESG_BASE_URL } from "@/api/system/message";
var deptRecipients = ref();
var userRecipients = ref();
/**
 * 绘制新增表单
 */
export function renderMessageAdd(el, save) {
  var addForm = new FormDialog(el, {
    items: items,
    elFormProps: {
      rules: rules
    },
    saveUrl: MESG_BASE_URL
  }, '新增', [{
    text: '取消',
    type: 'default',
    handler: function handler() {
      addForm.close();
    }
  }, {
    text: '保存',
    type: 'primary',
    handler: function handler(formData) {
      var params = _objectSpread({}, formData);
      if (formData.recipient === MESSAGE_RECIPIENT.DEPT.CODE) {
        params.deptRecipients = deptRecipients.value;
        params.userRecipients = [];
      } else if (formData.recipient === MESSAGE_RECIPIENT.USER.CODE) {
        params.userRecipients = userRecipients.value;
        params.deptRecipients = [];
      }
      params.status = MESSAGE_STATUS.DRAFTED.CODE;
      save(params);
    }
  }, {
    text: '发布',
    type: 'success',
    handler: function handler(formData) {
      var params = _objectSpread({}, formData);
      if (formData.recipient === MESSAGE_RECIPIENT.DEPT.CODE) {
        params.deptRecipients = deptRecipients.value;
        params.userRecipients = [];
      } else if (formData.recipient === MESSAGE_RECIPIENT.USER.CODE) {
        params.userRecipients = userRecipients.value;
        params.deptRecipients = [];
      }
      params.status = MESSAGE_STATUS.PUBLISHED.CODE;
      save(params);
    }
  }], '60%');
  addForm.onOpend = function () {
    deptRecipients.value = [];
    userRecipients.value = [];
  };
  return addForm;
}
var Recipient = defineComponent({
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup: function setup(props, ctx) {
    var value = computed({
      get: function get() {
        return props.modelValue || '';
      },
      set: function set(newValue) {
        ctx.emit('update:modelValue', newValue);
      }
    });
    return function () {
      return _createVNode("div", null, [_createVNode(ElRadioGroup, {
        "modelValue": value.value,
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return value.value = $event;
        }
      }, {
        default: function _default() {
          return [_createVNode(ElRadio, {
            "label": MESSAGE_RECIPIENT.ALL.CODE
          }, {
            default: function _default() {
              return [_createTextVNode("\u6240\u6709\u7528\u6237")];
            }
          }), _createVNode(ElRadio, {
            "label": MESSAGE_RECIPIENT.DEPT.CODE
          }, {
            default: function _default() {
              return [_createVNode("div", {
                "style": {
                  display: 'flex'
                }
              }, [_createVNode("span", {
                "style": {
                  paddingRight: '10px'
                }
              }, [_createTextVNode("\u6307\u5B9A\u90E8\u95E8")]), value.value === MESSAGE_RECIPIENT.DEPT.CODE ? _createVNode(DepartmentSelect, {
                "modelValue": deptRecipients.value,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return deptRecipients.value = $event;
                },
                "multiple": true,
                "placeholder": "\u9009\u62E9\u90E8\u95E8",
                "style": {
                  width: '250px'
                }
              }, null) : ''])];
            }
          }), _createVNode(ElRadio, {
            "label": MESSAGE_RECIPIENT.USER.CODE
          }, {
            default: function _default() {
              return [_createVNode("div", {
                "style": {
                  display: 'flex'
                }
              }, [_createVNode("span", {
                "style": {
                  paddingRight: '10px'
                }
              }, [_createTextVNode("\u6307\u5B9A\u7528\u6237")]), value.value === MESSAGE_RECIPIENT.USER.CODE ? _createVNode(UserSelector, {
                "modelValue": userRecipients.value,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return userRecipients.value = $event;
                },
                "multiple": true,
                "placeholder": "\u9009\u62E9\u7528\u6237",
                "style": {
                  width: '250px'
                }
              }, null) : ''])];
            }
          })];
        }
      })]);
    };
  }
});
var items = [[createFormItem('主题', 'subject', FORM_ITEM.INPUT, {
  clearable: true,
  maxlength: '256'
})], [createFormItem('内容', 'content', XTinyMce)], [createFormItem('类型', 'type', FORM_ITEM.SELECT, {
  loader: 'MESSAGE_TYPE'
})], [createFormItem('接收人', 'recipient', Recipient)], [createFormItem('备注', 'remark', FORM_ITEM.INPUT, {
  type: 'textarea',
  rows: 3,
  maxlength: '200',
  showWordLimit: true
})]];
var rules = {
  mailName: [{
    required: true,
    message: '请输入邮件名称',
    trigger: 'blur'
  }],
  mailCode: [{
    required: true,
    message: '请输入邮件代码',
    trigger: 'blur'
  }],
  mailType: [{
    required: true,
    message: '请输入邮件类型',
    trigger: 'blur'
  }],
  mailSubject: [{
    required: true,
    message: '请输入邮件主题',
    trigger: 'blur'
  }],
  mailContent: [{
    required: true,
    message: '请输入邮件正文',
    trigger: 'blur'
  }],
  to: [{
    required: true,
    message: '请选择收件人',
    trigger: 'blur'
  }]
};